@use '~styles/variables' as *;
@use '@timelyapp/design-system' as *;

:global(#login-app) {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.error {
  margin-top: 12px;
  padding: 10px 16px;
  border-radius: 8px;
  background-color: #fef2f2;
  color: #dc2626;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}

// Shown only when the login page is rendered inside the deprecated desktop
// app (Electron / "Timely/" UA), pointing those users at the web-app guide.
.deprecationNotice {
  margin-bottom: 20px;
  padding: 12px 16px;
  border-radius: 8px;
  background-color: #fffbeb;
  color: #92400e;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;

  p {
    margin: 0 0 6px;
  }

  a {
    font-weight: 700;
    color: #92400e;
    text-decoration: underline;
  }
}

.forgotPassword {
  margin-top: 16px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;

  a {
    color: $theme_color_content_subtle;
    text-decoration: none;

    &:hover {
      color: $theme_color_content_normal;
    }
  }
}

// No-op keyframe used as an autofill signal. Webkit/Chromium fire
// `animationstart` when `:-webkit-autofill` matches, so React's
// onAnimationStart can detect password-manager autofill on a hidden
// field and reveal it.
@keyframes onAutoFillStart {
  from {
    /* */
  }
  to {
    /* */
  }
}

.passwordInput:-webkit-autofill {
  animation-name: onAutoFillStart;
  animation-duration: 1ms;
}

.passwordHidden {
  height: 0;
  margin: 0;
  overflow: hidden;
  pointer-events: none;

  input {
    margin-bottom: 0;
    height: 0;
    padding: 0;
    border: 0;
  }

  label {
    display: none;
  }
}
